import { Combobox } from '@/components/common/Combobox'
import { operatorsFor } from './opCatalog'
import type { FieldEntry } from './types'

export function OpPicker({
  field, value, onChange,
}: {
  field: FieldEntry | null
  value: string
  onChange: (op: string) => void
}) {
  const ops = field ? operatorsFor(field.type) : []
  return (
    <Combobox<string>
      value={value || null}
      onChange={v => onChange(v ?? '')}
      options={ops.map(o => ({ value: o.id, label: o.label }))}
      emptyOptionLabel="— operator —"
      placeholder="— operator —"
      disabled={!field}
      className="w-40 text-sm"
    />
  )
}
